(() => {
  let animationsRunning = 0;

  window.addEventListener('animationstart', (e) => {
    if (e.pseudoElement) {
      return;
    }
    animationsRunning += 1;
  }, true);
  window.addEventListener('animationend', (e) => {
    if (e.pseudoElement) {
      return;
    }
    animationsRunning -= 1;
  }, true);
  window.addEventListener('animationcancel', (e) => {
    if (e.pseudoElement) {
      return;
    }
    animationsRunning -= 1;
  }, true);

  window.swinger = window.swinger || {};
  window.swinger.transition = {
    isSupported: () => {
      return false; // disabled
      // eslint-disable-next-line no-unreachable
      return !!document.startViewTransition;
    },
    tag: (elem, tag) => {
      elem.style.viewTransitionName = tag;
      elem.style.pageTransitionTag = tag;
      elem.style.contain = elem.style.contain || 'content';
    },
    untag: (elem) => {
      elem.style.viewTransitionName = '';
      elem.style.pageTransitionTag = '';
      elem.style.contain = '';
    },
    untagAll: () => {
      window.swinger
        .$('[style*="view-transition-name"], [style*="page-transition-tag"]')
        .forEach(window.swinger.transition.untag);
    },
    execute: (callback) => {
      switch (true) {
        default:
        case !window.swinger.transition.isSupported(): // This disables Transitions
        case animationsRunning > 0:
          callback();
          break;

        case !!document.startViewTransition:
          document.startViewTransition(async () => {
            console.log('executing transition');
            await new Promise((resolve) => {
              window.setTimeout(async () => {
                await callback();
                resolve();
              }, 50);
            });
          });
          break;
      }
    },
  };
})();
